import React from "react";
import PropTypes from "prop-types";
import ReactMarkdown from "react-markdown";
import rehypeRaw from "rehype-raw";
import { Image } from "@learningblocks/shared-components/lib/Image";
import style from "./style.module.scss";

export function GlossaryDetails(props) {
  return (
    <div className={style.detailsBlock}>
      <Image src={props.image} alt={props.title} />
      <h4>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{props.title}</ReactMarkdown>
      </h4>
      <div>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>
          {props.description.replace("\\_", "_")}
        </ReactMarkdown>
      </div>
    </div>
  );
}

GlossaryDetails.propTypes = {
  /**
   * Description of the option
   */
  description: PropTypes.string.isRequired,
  /**
   * Unique id for the option
   */
  id: PropTypes.string,
  /**
   * Image of the option
   */
  image: PropTypes.string.isRequired,
  /**
   * title of the option
   */
  title: PropTypes.string.isRequired,
};

GlossaryDetails.defaultProps = {
  description: "",
  id: 0,
  image: "",
  title: "",
};
